import { FC, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectTheme } from "../../features/theme/ThemeSlice";
import Sidebar from "../sidebar/Sidebar";
import Header from "../header/Header";
import Footer from "../footer/Footer";

const Layout: FC = () => {
  const theme = useAppSelector(selectTheme);
  const [rightSidebar, setRightSidebar] = useState<boolean>(false);
  const [leftSidebar, setLeftSidebar] = useState<boolean>(false);

  useEffect(() => {
    if (window.innerWidth < 992) {
      setLeftSidebar(true);
    }
  }, []);

  return (
    <div className={theme ? "mod-skin-dark" : ""}>
      <div className="page-wrapper">
        <div className="page-inner">
          <Sidebar leftSidebar={leftSidebar} />
          <div
            className={`page-content-wrapper ${
              rightSidebar ? "page-content-wrapper-right" : ""
            } ${leftSidebar ? "active" : ""}`}
          >
            <Header
              setRight={setRightSidebar}
              rightSidebar={rightSidebar}
              setLeft={setLeftSidebar}
              leftSidebar={leftSidebar}
            />
            <main id="js-page-content" role="main" className={`page-content `}>
              <Outlet />
            </main>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
